module.exports = __webpack_public_path__ + "img/Monte_Kope_108.55ed9be4.jpg";